export const selectAllPrices = ({ PricesSlice: oState }) => oState?.aPrices;
export const selectListPrice = ({ PricesSlice: oState }) => oState?.oList;
export const selectPricesStatus = ({ PricesSlice: oState }) => oState?.bStatus;
